export default __webpack_public_path__ + "static/media/ClementBethelbk.df8c265e.png";